import React from 'react'
import TutorSidebar from '../TutorSidebar/TutorSidebar'
import TutorFooter from '../TutorFooter/TutorFooter'
import { Link } from 'react-router-dom'

const TutorDashboard = () => {
    return (
        <div>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Tutor Dashboard
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="row mt-3">
                                    <div className="col-lg-4 col-md-6 mb-4">
                                        <Link to="/tutor/my-students">
                                            <div className="tutor-card-sec tutor-card-one">
                                                <Link to="/tutor/my-students">
                                                    <div className="img-sec">
                                                        <img
                                                            src="/assets/img/user/qwertyu.png"
                                                            className="img-fluid"
                                                        />
                                                    </div>
                                                </Link>
                                                <Link className="tutor-text text-center">
                                                    My Students
                                                </Link>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-4 col-md-6 mb-4">
                                        <Link to="/tutor/study-material">
                                            <div className="tutor-card-sec tutor-card-two">
                                                <Link to="/tutor/study-material">
                                                    <div className="img-sec">
                                                        <img
                                                            src="/assets/img/user/studymaterial.png"
                                                            className="img-fluid"
                                                        />
                                                    </div>
                                                </Link>
                                                <Link className="tutor-text text-center">
                                                    Study Material
                                                </Link>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-4 col-md-6 mb-4">
                                        <Link to="/tutor/my-courses">
                                            <div className="tutor-card-sec tutor-card-three">
                                                <Link to="/tutor/my-courses">
                                                    <div className="img-sec">
                                                        <img
                                                            src="/assets/img/user/qwerty.png"
                                                            className="img-fluid"
                                                        />
                                                    </div>
                                                </Link>
                                                <Link className="tutor-text text-center">
                                                    My Courses
                                                </Link>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-4 col-md-6 mb-4">
                                        <Link to="/tutor/my-earnings">
                                            <div className="tutor-card-sec tutor-card-four">
                                                <Link to="/tutor/my-earnings">
                                                    <div className="img-sec">
                                                        <img
                                                            src="/assets/img/user/myearning.png"
                                                            className="img-fluid"
                                                        />
                                                    </div>
                                                </Link>
                                                <Link className="tutor-text text-center">
                                                    My Earnings
                                                </Link>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-4 col-md-6 mb-4">
                                        <Link to="/tutor/browse-students">
                                            <div className="tutor-card-sec tutor-card-five">
                                                <Link to="/tutor/browse-students">
                                                    <div className="img-sec">
                                                        <img
                                                            src="/assets/img/user/browse.png"
                                                            className="img-fluid"
                                                        />
                                                    </div>
                                                </Link>
                                                <Link className="tutor-text text-center">
                                                Student Request
                                                </Link>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-4 col-md-6 mb-4">
                                        <Link to="/tutor/my-assessments-main">
                                            <div className="tutor-card-sec tutor-card-six">
                                                <Link to="/tutor/my-assessments-main">
                                                    <div className="img-sec">
                                                        <img
                                                            src="/assets/img/user/assignments.png"
                                                            className="img-fluid tutor-img-six"
                                                        />
                                                    </div>
                                                </Link>
                                                <Link className="tutor-text text-center">
                                                    My Assessments
                                                </Link>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </main>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorDashboard